import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import './CardPlay.scss';

function CardPlay(props) {
    return (
        <div className="card-play">
            <div className="card-play__top">
                {/*class:  border-radius-50 */}
                <LazyLoadImage className="card-play__top--image" src={props.image} alt="avatar" />
                <span className="card-play__top--icon-play">
                    <svg height="28" role="img" width="28" viewBox="0 0 24 24" aria-hidden="true"><polygon points="21.57 12 5.98 3 5.98 21 21.57 12" fill="currentColor"></polygon></svg>
                </span>
            </div>
            <div className="card-play__bottom">
                <div className="card-play__bottom--title">
                    <span className="card-play__bottom--title--text">{props.title}</span>
                </div>
                <div className="card-play__bottom--subtitle">
                    <span className="card-play__bottom--subtitle--text">{props.subtitle}</span>
                </div>
            </div>
        </div>
    );
}

export default CardPlay;